//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

	export default {
		name: "games-map",
        props: {
			url: {
				type: String,
                default: 'rugby/map'
            }
        },
        data() {
			return {
				markers: [],
				cover: null,
				width: 800,
				height: 420,
				center: {lat: 46.227638, lng: 2.213749000000007},
			}
        },
        created() {
			if( (typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1) ) {
				this.width = 350;
				this.height = 180;
			}
        },
        mounted() {
            this.loadGames();
        },
        methods: {
			loadGames() {
                window.Api.get(this.url).then(response => {
					if( response.success ) {
						let markers = response.data.markers;
						markers.forEach(game => {
							if( game.coordinates ) {
								const marker = {
									lat: parseFloat(game.coordinates.latitude),
									lng: parseFloat(game.coordinates.longitude),
								};

								this.markers.push({
                                    cover: game.cover,
									position: marker,
									icon: {
										url: game.icon,
										size: {width: 32, height: 32, f: 'px', b: 'px'},
										scaledSize: {width: 32, height: 32, f: 'px', b: 'px'}
									}
								});
                            }
						});
					}
                });
            },

			openInfoWindow(index) {
				this.cover = this.markers[index].cover;
				this.$modal.show('game-cover');
            }
        }
	}
